import { UPDATE_WALLET_BALANCE, CLEAR_PAYMENT_MESSAGES, UPDATE_WALLET_BALANCE_SUCCESS, UPDATE_WALLET_BALANCE_FAILED } from "../store/types";

export const INITIAL_STATE = {
  providers: [],
  message: null
}

export const paymentreducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case UPDATE_WALLET_BALANCE:
      return {
        ...state
      };
    case UPDATE_WALLET_BALANCE_SUCCESS:
      return {
        ...state
      };
    case UPDATE_WALLET_BALANCE_FAILED:
      return {
        ...state,
        message: action.payload
      };
    case CLEAR_PAYMENT_MESSAGES:
      return {
        ...state,
        message: null
      };
    default:
      return state;
  }
};